import React, { useState, MouseEventHandler } from "react";
import styled, { css } from "styled-components";
import IconButton from "./IconButton";
import cn from "classnames";

interface ITextInputProps {
  id: string;
  name: string;
  label?: string | undefined;
  type: string;
  value?: string | number;
  placeholder?: string | undefined;
  readonly?: boolean;
  variant?: string;
  require?: boolean;
  maxLength?: number;
  pattern?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: MouseEventHandler<HTMLInputElement>;
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>;
}

const TextInput = (props: ITextInputProps) => {
  const { id, name, label, type, variant, value, placeholder, readonly, require, maxLength, pattern, onKeyPress } = props;
  return (
    <TextInputSet className={variant}>
      {label && (
        <label htmlFor={id} className={cn({ required: require })}>
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        pattern={pattern}
        name={name}
        maxLength={maxLength}
        onChange={props.onChange}
        onClick={props.onClick}
        value={value}
        placeholder={placeholder}
        readOnly={readonly}
        onKeyPress={onKeyPress}
      />
    </TextInputSet>
  );
};

// TextInput
const TextInputSet = styled.div`
  label {
    position: relative;
    font-size: 16px;
    font-weight: bold;
    &.required {
      &::after {
        content: "*";
        position: absolute;
        top: -2px;
        right: -8px;
        display: block;
        font-size: 14px;
      }
    }
  }
  input {
    width: 100%;
    height: 37px;
    line-height: 37px;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.color.lineSecondary};
    background-color: transparent;
    color: ${({ theme }) => theme.color.secondary};
    font-size: 16px;
    font-family: "Roboto";
    font-weight: 400;
    &::placeholder {
      font-size: 14px;
      opacity: 50%;
    }
    &:focus {
      border-color: ${({ theme }) => theme.color.main};
      color: ${({ theme }) => theme.color.main};
    }
    &.inValid {
      border-color: ${({ theme }) => theme.color.warning};
      color: ${({ theme }) => theme.color.warning};
    }
    &[readonly],
    &[readonly="readonly"] {
      border-bottom: none;
    }
  }

  &.contained {
    > input {
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 15px;
      border: none;
      border-radius: 4px;
      background-color: ${({ theme }) => theme.color.bgPrimary};
      color: #001827;
    }
  }
  & + & {
    margin-top: 30px;
  }
`;

export default TextInput;
